import styled from "styled-components";

const Radio = styled.section`
  margin-top: ${(props) => props.marginTop ? props.marginTop : "20px"};
  display: flex;
  justify-content: center;
  align-items: center;
  gap:1rem;
  background: ${(props) => props.backgroundColour ? props.backgroundColour : "#f9fcff"} ;
  border: 1px solid #436ab2;
  padding: 1rem 2rem;
  border-radius: 10px;
  font-size: 16px;
  display: flex;
  user-select: none;
  cursor: pointer;
  transition: 0.2s all ease-in-out;
  /* &:hover {
    background-color: #e6f0ff;
  } */
`;

const Next = styled.div`
  margin-top: ${(props) => props.marginTop ? props.marginTop : "20px"};
  display: flex;
  justify-content: center;
  align-items: center;
  gap:2rem;
  background: ${(props) => props.backgroundColour ? props.backgroundColour : "#f9fcff"} ;
  width: 250px;
  height: 54px;
  border: 1px solid #436ab2;
  padding: 1rem 1.2rem;
  border-radius: 10px;
  font-size: 16px;
  display: flex;
  user-select: none;
  cursor: pointer;
  transition: 0.2s all ease-in-out;
  /* &:hover {
    background-color: #e6f0ff;
  } */
`;

const Reupload = styled.section`
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap:2rem;
  background: #E5F7FF;
  min-width: 250px;
  padding: 1rem 2rem;
  border-radius: 10px;
  font-size: 16px;
  display: flex;
  user-select: none;
  /* cursor: pointer; */
  transition: 0.2s all ease-in-out;
  /* &:hover {
    background-color: #e6f0ff;
  } */
`;


const RadioWrapper = styled.section`
  margin-bottom: 1.2rem;
`;

const Image = styled.img`
  width: 2rem;
  margin-right: 2rem;
  user-select: none;
  pointer-events: none;
`;

const RadioListWrapper = styled.section`
  margin-top: 4rem;
  display: flex;
  flex-direction: column;
  gap: 20px;
  /* justify-content: space-between; */
  width: 100%;
`;

const Divider = styled.div`
  height: 1px;
  background-color: #436AB2;
  margin: 2rem 0;
`;

export { Radio, RadioWrapper, Image, RadioListWrapper, Reupload, Divider, Next};
